import { QueryClient } from '@tanstack/react-query';

import { api } from './api';

/** One QueryClient for REST (docs/04 §1: TanStack Query for REST, zustand for live state). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

/**
 * Starts `GET /home` the moment a session exists, instead of when the Home screen mounts
 * (UX-110). Pairing → a usable Home was measured at 16–32 s, of which 3.5–13 s was Home
 * waiting on its own first request; issuing it during the hand-off overlaps that wait with
 * the screen transition. It is the same query key the screen uses, so the screen picks the
 * result up instead of asking again, and a failure here is not an error: the screen retries.
 */
export function prefetchHome(): void {
  void queryClient.prefetchQuery({ queryKey: ['home'], queryFn: () => api.home() });
}
